import { injectable } from 'inversify';
import { ErrorHandler, Result } from './Result';

interface ErrorText {
  message: string;
  details: string;
}

interface Error {
  error_code: number;
  error_details: ErrorText;
}

interface ErrorEnvelope {
  errors: Error[];
}

@injectable()
export class AxiosErrorHandler implements ErrorHandler {
  handleError(error: any) {
    let msg = 'Network error occurred.';
    if (error && error.response && error.response.data) {
      const envelope = error.response.data as ErrorEnvelope;
      if (envelope.errors && Array.isArray(envelope.errors) && envelope.errors.length >= 1) {
        msg = envelope.errors[0].error_details.message;
      }
    }

    const newError: Result<any> = {
      errorMessage: msg,
      data: null,
      isError: true,
    };
    return newError;
  }
}
